var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("layout", { attrs: { "no-sidebar": true } }, [
    _c("div", { staticClass: "page-header" }, [
      _c("h1", [
        _c("small", [
          _vm._v(
            "Reservation Action: " + _vm._s(_vm.action.reservation_number || "")
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-right" },
        [
          _c(
            "router-link",
            {
              staticClass: "btn btn-default",
              attrs: { to: { name: "reservationActions.all" } }
            },
            [_vm._v("\n        Back\n      ")]
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _vm.loading
      ? _c("div", { staticClass: "text-center" }, [
          _c("i", { staticClass: "fa fa-spinner fa-spin fa-3x fa-fw" })
        ])
      : _vm.errorMessage
      ? _c("div", { staticClass: "alert alert-danger" }, [
          _vm._v("\n    " + _vm._s(_vm.errorMessage) + "\n  ")
        ])
      : _c("div", [
          _c("table", { staticClass: "table table-bordered" }, [
            _c("tbody", [
              _c("tr", [
                _c("th", [_vm._v("ID")]),
                _c("td", [_vm._v(_vm._s(_vm.display(_vm.action.id)))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Reservation Number")]),
                _c("td", [
                  _vm._v(_vm._s(_vm.display(_vm.action.reservation_number)))
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Action")]),
                _c("td", [
                  _vm._v(_vm._s(_vm.formatLabel(_vm.action.action_type)))
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Action Date")]),
                _c("td", [
                  _vm._v(_vm._s(_vm.formatDate(_vm.action.action_date)))
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Reservation Created At")]),
                _c("td", [
                  _vm._v(
                    _vm._s(_vm.formatDate(_vm.action.reservation_created_at))
                  )
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Email")]),
                _c("td", [_vm._v(_vm._s(_vm.display(_vm.action.email)))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Phone")]),
                _c("td", [_vm._v(_vm._s(_vm.display(_vm.action.phone)))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Reserved By")]),
                _c("td", [_vm._v(_vm._s(_vm.display(_vm.action.reserved_by)))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Reserved For")]),
                _c("td", [_vm._v(_vm._s(_vm.display(_vm.action.reserved_for)))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Location")]),
                _c("td", [
                  _vm._v(_vm._s(_vm.display(_vm.action.location_name)))
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Channel")]),
                _c("td", [_vm._v(_vm._s(_vm.display(_vm.action.channel_name)))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Grand Total")]),
                _c("td", [_vm._v(_vm._s(_vm.display(_vm.action.grand_total)))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Start Date")]),
                _c("td", [
                  _vm._v(_vm._s(_vm.formatDate(_vm.action.start_date)))
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("End Date")]),
                _c("td", [_vm._v(_vm._s(_vm.formatDate(_vm.action.end_date)))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Testing")]),
                _c("td", [_vm._v(_vm._s(_vm.action.testing ? "Yes" : "No"))])
              ])
            ])
          ])
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fa26a570", { render: render, staticRenderFns: staticRenderFns })
  }
}